import gql from "graphql-tag";

export const createUpdateSDMEncounter = gql`
  mutation createUpdateSDMEncounter(
    $patientId: Int!
    $version: Int!
    $status: String!
  ) {
    createUpdateSDMEncounter(
      patientId: $patientId
      version: $version
      status: $status
    ) {
      id
    }
  }`;
